// Content and surface flags from Wolfenstein: Enemy Territory (surfaceflags.h).

export const CONTENTS_SOLID = 0x1;
export const CONTENTS_LIGHTGRID = 0x4;
export const CONTENTS_LAVA = 0x8;
export const CONTENTS_SLIME = 0x10;
export const CONTENTS_WATER = 0x20;
export const CONTENTS_FOG = 0x40;
export const CONTENTS_MISSILECLIP = 0x80;
export const CONTENTS_ITEM = 0x100;
export const CONTENTS_MOVER = 0x4000;
export const CONTENTS_AREAPORTAL = 0x8000;
export const CONTENTS_PLAYERCLIP = 0x10000;
export const CONTENTS_MONSTERCLIP = 0x20000;
export const CONTENTS_TELEPORTER = 0x40000;
export const CONTENTS_JUMPPAD = 0x80000;
export const CONTENTS_CLUSTERPORTAL = 0x100000;
export const CONTENTS_DONOTENTER = 0x200000;
export const CONTENTS_DONOTENTER_LARGE = 0x400000;
export const CONTENTS_ORIGIN = 0x1000000;
export const CONTENTS_BODY = 0x2000000;
export const CONTENTS_CORPSE = 0x4000000;
export const CONTENTS_DETAIL = 0x8000000;
export const CONTENTS_STRUCTURAL = 0x10000000;
export const CONTENTS_TRANSLUCENT = 0x20000000;
export const CONTENTS_TRIGGER = 0x40000000;
export const CONTENTS_NODROP = 0x80000000 | 0;

export const SURF_NODAMAGE = 0x1;
export const SURF_SLICK = 0x2;
export const SURF_SKY = 0x4;
export const SURF_LADDER = 0x8;
export const SURF_NOIMPACT = 0x10;
export const SURF_NOMARKS = 0x20;
export const SURF_SPLASH = 0x40;
export const SURF_NODRAW = 0x80;
export const SURF_HINT = 0x100;
export const SURF_SKIP = 0x200;
export const SURF_NOLIGHTMAP = 0x400;
export const SURF_POINTLIGHT = 0x800;
/** Clanking footsteps (SURF_METAL in ET). */
export const SURF_METALSTEPS = 0x1000;
/** No footstep sounds. */
export const SURF_NOSTEPS = 0x2000;
export const SURF_NONSOLID = 0x4000;
export const SURF_LIGHTFILTER = 0x8000;
export const SURF_ALPHASHADOW = 0x10000;
export const SURF_NODLIGHT = 0x20000;
// footstep materials (BG_FootstepForSurface)
export const SURF_WOOD = 0x40000;
export const SURF_GRASS = 0x80000;
export const SURF_GRAVEL = 0x100000;
export const SURF_GLASS = 0x200000;
export const SURF_SNOW = 0x400000;
export const SURF_ROOF = 0x800000;
export const SURF_RUBBLE = 0x1000000;
export const SURF_CARPET = 0x2000000;

export const MASK_ALL = -1;
export const MASK_SOLID = CONTENTS_SOLID;
export const MASK_PLAYERSOLID = CONTENTS_SOLID | CONTENTS_PLAYERCLIP | CONTENTS_BODY;
export const MASK_WATER = CONTENTS_WATER | CONTENTS_LAVA | CONTENTS_SLIME;
